<!-- Created by henian.xu on 2020/5/22. -->

<template>
    <div class="edit-study-history">
        <el-form
            ref="form"
            class="el-table el-table--small"
            size="small"
            :model="formModel"
            :rules="formRules"
        >
            <table>
                <thead>
                    <tr>
                        <th v-if='degreeDictionary'><div class="cell">程度</div></th>
                        <th><div class="cell">所在院校</div></th>
                        <th><div class="cell">毕业时间</div></th>
                        <th><div class="cell">毕业证编码</div></th>
                        <th><div class="cell">操作</div></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item,index) in formModel"
                        :key="index"
                    >
                        <td v-if='degreeDictionary'>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.education`"
                                    :rules="formRules.required">
                                    <RemoteSelect
                                        :data="`[DICTIONARY]:${degreeDictionary}`"
                                        v-model="item.education"/>
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.school`"
                                    :rules="formRules.required">
                                    <el-input v-model="item.school"/>
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.graduationDate`"
                                    :rules="formRules.required">
                                    <el-date-picker
                                        type="date"
                                        v-model="item.graduationDate"
                                        format="yyyy年MM月dd日"
                                        value-format="yyyy年MM月dd日"
                                    />
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-form-item
                                    :prop="`${index}.idCode`">
                                    <el-input v-model="item.idCode"/>
                                </el-form-item>
                            </div>
                        </td>
                        <td>
                            <div class="cell">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="onDel(item,index)"
                                >
                                    删除
                                </el-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="100">
                            <div class="cell">
                                <el-button
                                    v-if="!maxCount||(maxCount && formModel.length<maxCount)"
                                    type="success"
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="onAdd"
                                >
                                    添加经历
                                </el-button>
                                <div
                                    v-else-if="maxCount"
                                    class="tc-minor">最多添加 {{maxCount}} 条</div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </el-form>
    </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter';

export default {
    name: 'EditStudyHistory',
    mixins: [emitter],
    data() {
        return {
            formModel: [],
            formRules: {
                required: {
                    required: true,
                    message: '不能为空',
                },
            },
            onConfirm_: null,
            innerCtrl__: false,
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '添加经历',
        },
        degreeDictionary: {
            type: String,
            default: 'education',
        },
        maxCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
                this.dispatch('ElFormItem', 'el.form.change', [val]);
            },
        },
        fields() {
            return this.$refs.form.fields;
        },
    },
    watch: {
        formModel: {
            handler() {
                if (!this.onConfirm_) {
                    this.onConfirm_ = this.$utils.debounce(this.onConfirm, 500);
                }
                this.onConfirm_();
            },
            deep: true,
        },
        model: {
            handler(val) {
                if (this.innerCtrl__) {
                    this.innerCtrl__ = false;
                    return;
                }
                try {
                    this.formModel = JSON.parse(JSON.stringify(val));
                } catch (e) {
                    // noop
                }
            },
            immediate: true,
        },
    },
    methods: {
        onAdd() {
            this.formModel.push({
                education: '', // 程度(学历)
                school: '', // 所在院校
                isSoFar: 1, // 值为:1;0
                graduationDate: '', // 毕业时间
                idCode: '', // 毕业证编码
            });
        },
        onDel(item, index) {
            this.formModel.splice(index, 1);
        },
        async validate(callback) {
            return this.$refs.form.validate(callback);
        },
        async onConfirm() {
            await this.validate();
            this.innerCtrl__ = true;
            this.model = [...this.formModel];
        },
    },
};
</script>

<style lang="scss">
.edit-study-history {
    > .el-table {
        > table {
            width: 100%;
            border-collapse: collapse;

            tr {
                > th,
                > td {
                    border: 1px solid $color-border;
                }
            }
        }
    }
}
</style>
